import React from "react";
import { Clock, RefreshCw, Search, Send, AlertCircle } from "lucide-react";

const icons = { search: Search, send: Send, error: AlertCircle, skip: Clock, alert: AlertCircle, report: Send };

const SKIP = { no_target: "aucun prospect avec email à contacter", suppressed: "contact désinscrit" };

const describe = (l) => {
  if (l.type === "send") return `Email ${l.kind} → ${l.societe} (${l.status})`;
  if (l.type === "report") return `Bilan hebdo envoyé à ${l.to} : ${l.sent_total} emails, ${l.replies_total} réponses, ${l.imported_total} prospects (${l.status})`;
  if (l.type === "alert") return `Alerte inactivité envoyée à ${l.to} : ${l.missed_days} jour(s) ouvré(s) sans envoi (${l.status})`;
  if (l.type === "search") {
    const found = l.emails_found ? `, ${l.emails_found} email(s) retrouvé(s)` : "";
    return l.error ? `Recherche ${l.sector} / ${l.ville} en erreur : ${l.error}` : `Recherche ${l.sector} / ${l.ville} → ${l.imported} entreprise(s) importée(s)${found}`;
  }
  if (l.type === "error") return `Erreur : ${l.error || l.societe}`;
  if (l.type === "skip") {
    const extra = l.reason === "no_target" && l.prospects_sans_email ? ` (${l.prospects_sans_email} prospect(s) « nouveau » sans email)` : "";
    return `Ignoré : ${SKIP[l.reason] || l.reason}${extra}`;
  }
  return "";
};

const AutopilotLog = ({ logs, onRefresh }) => (
  <div className="mt-8" data-testid="autopilot-log">
    <div className="flex items-center justify-between mb-3">
      <h3 className="font-semibold text-neutral-800">Journal d'activité</h3>
      <button onClick={onRefresh} className="flex items-center gap-1.5 text-sm text-neutral-600 hover:text-brand"><RefreshCw size={14} /> Actualiser</button>
    </div>
    {logs.length === 0 ? (
      <p className="text-sm text-neutral-400">Aucune activité pour le moment.</p>
    ) : (
      <div className="space-y-2">
        {logs.map((l) => {
          const Icon = icons[l.type] || Clock;
          return (
            <div key={l.id} className="flex items-center gap-3 bg-white border border-neutral-200 rounded-lg px-4 py-2.5 text-sm">
              <Icon size={15} className={l.status === "error" ? "text-red-500" : "text-brand"} />
              <span className="text-neutral-400 text-xs w-32 shrink-0">{new Date(l.created_at).toLocaleString("fr-FR")}</span>
              <span className="text-neutral-700 flex-1 truncate">{describe(l)}</span>
            </div>
          );
        })}
      </div>
    )}
  </div>
);

export default AutopilotLog;
